import { createAsyncSelectors } from '@lib/selectors';
import { Initiative } from '@sonar-software/sonar-core';
import { useSonarSelector } from '../useSonarSelector';

const selectors = createAsyncSelectors((state) => state.core.initiatives.byId.get);

/** Subscribes to the currently loaded {@link Initiative}, if any. */
export function useCurrentInitiative(): Initiative | null | undefined {
	return useSonarSelector(selectors.data);
}

useCurrentInitiative.selectors = selectors;
